import Http from '../index.js'
import Model from '../Model.js'

class Contacts extends Model {
  constructor() {
    super('/contacts/')
  }

  list(query = '', config = {}) {
    return Http.get(`${this.model}list_contacts/${query}`, config)
  }

  create(payload, config = {}) {
    return Http.post(
      `${this.model}create_contact/`,
      {
        ...payload,
      },
      config,
    )
  }

  createDependent(payload, config = {}) {
    return Http.post(`${this.model}create_dependent/`, payload, config)
  }

  getBankAccounts(id, config = {}) {
    return Http.get(`${this.model}${id}/contact_transfer_destinations/`, config)
  }

  read(id, config = {}) {
    return Http.get(`${this.model}${id}/contact_info/`, config)
  }

  update(payload, config = {}) {
    return Http.post(
      `${this.model}update_contact/`,
      {
        ...payload,
      },
      config,
    )
  }

  createBankOrAddress(payload, config = {}) {
    return Http.post(
      `${this.model}create_address_or_bank_account_for_contact/`,
      {
        ...payload,
      },
      config,
    )
  }

  makeBankAccountPrimaryForContact(payload, config = {}) {
    return Http.post(`${this.model}make_bank_account_primary_for_contact/`, payload, config)
  }

  importFromCsv(file) {
    return Http.post(`${this.model}import_contacts_from_csv/`, file)
  }

  contactsLot(payload, config = {}) {
    return Http.post(`${this.model}create_contact_lot/`, payload, config)
  }

  delete(payload, config = {}) {
    return Http.post(`${this.model}delete_contact/`, payload, config)
  }

  updateContactStatus(id, active) {
    return Http.post(`${this.model}${id}/update_contact_status/`, { active })
  }
}

export default new Contacts()
